import { Slot } from "@radix-ui/react-slot";
import { cn } from "@scott/ui/utils/cn";
import type { ImgHTMLAttributes } from "react";

interface facebookProps extends ImgHTMLAttributes<HTMLImageElement> {
  asChild?: boolean;
}

const Facebook = ({ className, asChild = false }: facebookProps) => {
  const Comp = asChild ? Slot : "svg";
  return (
    <Comp
      className={cn("fill-[--brand-followus-logo]", className)}
      fill="none"
      height="32"
      viewBox="0 0 28 28"
      width="28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 0H24C26.1875 0 28 1.8125 28 4V24C28 26.25 26.1875 28 24 28H15.9375V18.9375H20.25L21.125 14H15.9375V12.3125C15.9375 9.6875 16.9375 8.6875 19.5625 8.6875C20.375 8.6875 21 8.75 21.375 8.75V4.375C20.6875 4.125 18.9375 3.9375 17.9375 3.9375C12.5625 3.9375 10.125 6.5 10.125 11.9375V14H6.8125V18.9375H10.125V28H4C1.75 28 0 26.25 0 24V4C0 1.8125 1.75 0 4 0Z" />
    </Comp>
  );
};

Facebook.displayName = "Facebook";

export { Facebook };
